module.exports = __webpack_public_path__ + "static/media/loading.40593b86.gif";